import Link from "next/link";
import {twMerge} from "tailwind-merge";
import {ImageWithFallback} from "@/components";
import {IMAGE_URL} from "@/constants/general-constants";
import {isEmpty} from "@/utils/global-functions";

export default function PremierFreelancerCard({data = {}, centerResponsive, classes = {}, categoryData = {}}) {

    const {avatar = "", name = "", service_category = "", is_top = 0, username = ""} = data;

    const {parentClasses = "", imageClasses = "", signClasses = "", signTriangleClasses = ""} = classes;

    return (
        <div className={twMerge("group relative pt-11 lg:min-w-[16.563rem]", parentClasses)}>
            <div
                className={twMerge(`absolute z-10 w-[8.188rem] h-[8.188rem] lg:w-[8.125rem] lg:h-[8.125rem] top-0 rounded-[1.813rem] overflow-hidden border-2 border-pol-blue-light group-hover:border-pol-blue duration-300 ${centerResponsive ? "right-[calc(50%-4.094rem)] lg:right-[1.125rem]" : "right-[1.125rem]"}`, imageClasses)}>
                <ImageWithFallback
                    className="object-cover"
                    fill
                    src={IMAGE_URL + avatar}
                    alt={name}
                />
            </div>
            <div
                className="relative flex flex-col h-full bg-white border-2 border-pol-blue-light px-[1.125rem] pb-[1.125rem] pt-[6.875rem] rounded-l-[1.063rem] rounded-r-[1.625rem] font-semibold group-hover:border-pol-blue duration-300">
                {
                    centerResponsive && is_top ?
                        <div className="absolute -top-1.5">
                            <div
                                className={twMerge("relative w-10 h-[3.125rem] bg-pol-blue rounded-[0.188rem]", signClasses)}>
                                <div
                                    className={twMerge("triangle triangle-l-white border-x-[1rem] border-b-[0.563rem] border-t-0 absolute -bottom-px right-1 text-lg flex-center", signTriangleClasses)}>
                                    <i className="icon-cup text-white mb-9"/>
                                </div>
                            </div>
                        </div> : null
                }
                <div className="flex absolute -top-1.5 left-[1.125rem] space-x-[0.188rem] space-x-reverse">
                    {
                        !centerResponsive && is_top ?
                            <div
                                className={twMerge("relative w-10 h-[3.125rem] bg-pol-blue rounded-[0.188rem]", signClasses)}>
                                <div
                                    className={twMerge("triangle triangle-l-white border-x-[1rem] border-b-[0.563rem] border-t-0 absolute -bottom-px right-1 text-lg flex-center", signTriangleClasses)}>
                                    <i className="icon-cup text-white mb-9"/>
                                </div>
                            </div>
                            : null
                    }
                    <div
                        className={twMerge("relative w-10 h-[3.125rem] bg-pol-orange-dark rounded-[0.188rem]", signClasses)}>
                        <div
                            className={twMerge("triangle triangle-l-white border-x-[1rem] border-b-[0.563rem] border-t-0 absolute -bottom-px right-1 text-xl flex-center", signTriangleClasses)}>
                            <i className="icon-verified-badge text-white mb-9"/>
                        </div>
                    </div>
                </div>
                <p className={`text-lg text-pol-dark ${centerResponsive ? "text-center" : ""}`}>
                    <i className="icon-fingerprint ml-3"/>
                    {name}
                </p>
                <p className={`flex items-center text-sm text-pol-light-brown-5 mt-2.5 mb-5 ${centerResponsive ? "text-center" : ""}`}>
                    <i className="icon-bag ml-3 text-lg"/>
                    {service_category}
                </p>
                <Link href={isEmpty(categoryData) ? `/profile/${username}` : `/profile/${username}?${categoryData?.level === 2 ? "secondary_service_category" : "service_category"}=${categoryData.id}`}
                      className={`inline-block w-full border border-pol-light-brown flex items-center text-sm text-pol-light-brown-6 mt-auto px-3.5 py-3 rounded-[0.688rem] group-hover:border-pol-blue group-hover:text-pol-blue duration-300 ${centerResponsive ? "justify-center" : "justify-between"}`}>
                    <span className={centerResponsive ? "ml-3" : ""}>مشاهده پروفایل</span>
                    <i className="icon-arrow-left text-pol-light-brown-6 text-xs group-hover:text-pol-blue duration-300"/>
                </Link>
            </div>
        </div>
    )
}
